module.exports = __webpack_public_path__ + "img/service_history.c9d12f75.svg";